import { createModel } from '@/store/tools';

const model = {
    namespace: 'baseset_mood',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getTableSource': T('getTableSource'),
            'getDetail': T('getDetail'),
        },
        actions: {
            'getTableSource': A('getTableSource'),
            'getDetail': A('getDetail'),
        },
        sagas: {
            'getTableSource': S('getTableSource', '/?cmd=com.xqxc.api.pig.mis.biz.user.MaterialMisService.list'),
            'getDetail': S('getDetail', '/?cmd=com.xqxc.api.pig.mis.biz.user.MaterialMisService.MaterialDetail'),
        },
        reducers: {
            'tableSource': R('getTableSource', []),
            'detail': R('getDetail', {}),
        }
    })
};
export default createModel(model);